export default __webpack_public_path__ + "static/media/12.c925545b.gif";